import { Visibility, VisibilityOff } from '@mui/icons-material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Button, IconButton, InputAdornment, Popover } from '@mui/material';
import apiManagerUser from 'api/manager-users';
import { IconClose } from 'assets/icons';
import TextFieldVMP from 'components/common/TextField/TextFieldVMP';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillCheckCircle, AiFillCloseCircle } from 'react-icons/ai';
import { BiRadioCircle } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import { setCloseModal } from 'store/modal/modalSlice';
import { setUserInfo } from 'store/user/userInfoSlice';
import theme from 'theme';
import { toastError, toastSuccess } from 'utils/helpers';
import { isValidPwdATTT, isValidStringNotContainWhiteSpace } from 'utils/validates';

export default function ChangeUserp() {
    const [showPass, setShowPass] = useState(false);
    const [showRePass, setShowRePass] = useState(false);
    const [password, setPassword] = useState('')
    const [rePassword, setRePassword] = useState('')
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.userInfo.userInfo);
    const [listError, setlistError] = useState([]);
    const [errorRePass, setErrorRePass] = useState({ value: true, text: '' })

    const stylePass = {
        color: 'green',
        display: 'flex',
        alignItems: 'center',
        textRendering: 'geometricPrecision'
    }
    const styleFail = {
        color: 'red',
        display: 'flex',
        alignItems: 'center',
        textRendering: 'geometricPrecision'
    }
    const styleEmpty = {
        color: 'grey',
        display: 'flex',
        alignItems: 'center',
        textRendering: 'geometricPrecision'
    }

    function isValidPwdATTTUsername(pwd, userInfo) {
        if (pwd) {
            const username = userInfo?.username || userInfo;
            return !pwd.toLowerCase()?.includes(username.toLowerCase())
        }
    }

    const handleClickShowPass = () => setShowPass(!showPass);
    const handleClickShowRePass = () => setShowRePass(!showRePass);

    const focusInput = () => {
    }
    const unfocusInput = () => {
        setAnchorEl(null)
    }

    const [anchorEl, setAnchorEl] = useState(null);

    const updateUserInfo = (data) => {
        return apiManagerUser.updateUserInfo(data)
    }

    const handleCheckRePass = (pass, rePass) => {
        if (pass !== rePass) {
            setErrorRePass({ value: false, text: t('validate.pwdIsSame') })
            return { value: false, text: t('validate.pwdIsSame') }
        } else {
            setErrorRePass({ value: true, text: '' })
            return { value: true, text: '' }
        }
    }

    const handleUpdatePass = () => {
        const result = handleCheckRePass(password, rePassword);
        if (!result.value) {
            return;
        }

        updateUserInfo({ password })
            .then(result => {
                dispatch(setUserInfo({
                    ...userInfo,
                    password
                }))
                toastSuccess(t('toast.contentUpdateSuccess'))
                // toastSuccess(<ToastCard title={'Cập nhật thành công'} content={'Thông tin của bạn đã được cập nhật'} type='success' />, TOAST_POSITION.topCenter);
                dispatch(setCloseModal())
            })
            .catch(error => {
                toastError("Có lỗi xảy ra")
            })
    }

    useEffect(() => {
        let errors = [];
        if (!/^(?=.*[!@#$%^&*])/.test(password)) {
            errors.push("One_Special");
        } else {
            errors?.filter(error => error !== "One_Special")
        }

        if (!/^(?=.{8,})/.test(password)) {
            errors.push("8_Characters");
        } else {
            errors?.filter(error => error !== "8_Characters")
        }

        if (!/^(?=.*[0-9])/.test(password)) {
            errors.push("One_Number");
        } else {
            errors?.filter(error => error !== "One_Number")
        }

        if (!/^(?=.*[a-z])/.test(password)) {
            errors.push("One_Lowercase");
        } else {
            errors?.filter(error => error !== "One_Lowercase")
        }

        if (!/^(?=.*[A-Z])/.test(password)) {
            errors.push("One_Uppercase");
        } else {
            errors?.filter(error => error !== "One_Uppercase")
        }
        if (!isValidPwdATTT(password, userInfo)) {
            errors.push("ATTT");
        } else {
            errors?.filter(error => error !== "ATTT")
        }
        if (!isValidPwdATTTUsername(password, userInfo)) {
            errors.push("ATTT_username");
        } else {
            errors?.filter(error => error !== "ATTT_username")
        }
        if (errors.length > 0) {
            setlistError(errors)
        } else {
            setlistError([])
        }
        if (!isValidStringNotContainWhiteSpace(password)) {
            errors.push("White_Space")
        }
        if (password.length > 32) {
            setlistError(prevData => [...prevData, t('validate.max32Text')])
        }
        return () => {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [password])

    return (
        <div style={{ display: 'flex', flexDirection: 'column', padding: '1rem 2rem' }}>
            <div style={{ display: 'flex', justifyItems: 'center', justifyContent: 'center', fontWeight: '500', fontSize: '26px' }}>{t('popup.change-pass.title')}</div>
            <div style={{ position: 'relative' }}>
                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    sx={{ borderRadius: theme.spacing(1.5), marginLeft: '20px', pointerEvents: 'none' }}

                >
                    <Box sx={{ padding: '1rem' }}>
                        <div style={{ fontWeight: '600' }}>{t('popupCheckPass.requireLengthPass')}:</div>
                        <div style={!password ? styleEmpty : (listError.includes("8_Characters") ? styleFail : stylePass)}>
                            {!password ? <BiRadioCircle size={13} /> : (listError.includes("8_Characters") ? <AiFillCloseCircle size={13} /> : <AiFillCheckCircle size={13} />)}
                            <span>{t('common.characters', { num: 8 })}</span>
                        </div>
                        {/* <div>{password}</div> */}
                        <div style={!password ? styleEmpty : (listError.includes("One_Number") ? styleFail : stylePass)}>
                            {!password ? <BiRadioCircle size={13} /> : (listError.includes("One_Number") ? <AiFillCloseCircle size={13} /> : <AiFillCheckCircle size={13} />)}
                            &nbsp;1 {t('popupCheckPass.number')}
                        </div>
                        <div style={!password ? styleEmpty : (listError.includes("One_Uppercase") ? styleFail : stylePass)}>
                            {!password ? <BiRadioCircle size={13} /> : (listError.includes("One_Uppercase") ? <AiFillCloseCircle size={13} /> : <AiFillCheckCircle size={13} />)}
                            &nbsp;1 {t('popupCheckPass.upperLetters')}</div>
                        <div style={!password ? styleEmpty : (listError.includes("One_Lowercase") ? styleFail : stylePass)}>
                            {!password ? <BiRadioCircle size={13} /> : (listError.includes("One_Lowercase") ? <AiFillCloseCircle size={13} /> : <AiFillCheckCircle size={13} />)}
                            &nbsp;1 {t('popupCheckPass.lowerLetters')}</div>
                        <div style={!password ? styleEmpty : (listError.includes("One_Special") ? styleFail : stylePass)}>
                            {!password ? <BiRadioCircle size={13} /> : (listError.includes("One_Special") ? <AiFillCloseCircle size={13} /> : <AiFillCheckCircle size={13} />)}
                            &nbsp;1 {t('popupCheckPass.specialCharacters')}</div>
                        <div style={{ marginTop: '8px', fontWeight: '600' }}>{t('popupCheckPass.notContain')}:</div>
                        {/* <div style={ !password ? styleEmpty : ((!ref.current.values.username) ?  {color: 'green'} :(listError.includes("ATTT_username") ? styleFail : stylePass))}>
                        {(!password) ? <BiRadioCircle size={13} /> : (listError.includes("ATTT_username") ?  <AiFillCloseCircle size={13} /> : <AiFillCheckCircle size={13} />)}
                            &nbsp;{t('popupCheckPass.username')}</div> */}
                        <div style={!password ? styleEmpty : (listError.includes("ATTT") ? styleFail : stylePass)}>
                            {!password ? <BiRadioCircle size={13} /> : (listError.includes("ATTT") ? <AiFillCloseCircle size={13} /> : <AiFillCheckCircle size={13} />)}
                            &nbsp;{t('popupCheckPass.blackList')}</div>
                        <div style={!password ? styleEmpty : (listError.includes("White_Space") ? styleFail : stylePass)}>
                            {!password ? <BiRadioCircle size={13} /> : (listError.includes("White_Space") ? <AiFillCloseCircle size={13} /> : <AiFillCheckCircle size={13} />)}
                            &nbsp;{t('popupCheckPass.whitespace')}</div>
                    </Box>
                </Popover>
                <TextFieldVMP
                    onFocus={focusInput}
                    onBlur={unfocusInput}
                    onClick={e => setAnchorEl(e.currentTarget)}
                    placeholder={t('user.password')}
                    style={{ marginTop: '30px' }}
                    type={showPass ? 'text' : 'password'}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    error={(listError[listError.length - 1] === t('validate.max32Text'))}
                    helperText={(listError[listError.length - 1] === t('validate.max32Text') && t('validate.max32Text'))}
                    InputProps={{
                        // <-- This is where the toggle button is added.
                        startAdornment: (
                            <InputAdornment position="start">
                                <LockOutlinedIcon sx={{ color: '#949595' }} />
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">
                                {password !== '' ? (
                                    <IconButton
                                        tabIndex={-1}
                                        aria-label="toggle password visibility"
                                        onClick={() => { setPassword('') }}
                                        sx={{ p: 0.5 }}
                                    >
                                        <IconClose />
                                    </IconButton>
                                ) : (
                                    <></>
                                )}
                                <IconButton
                                    tabIndex={-1}
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPass}
                                    sx={{ p: 0.5 }}
                                >
                                    {showPass ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
            <TextFieldVMP
                placeholder={t('user.rePassword')}
                style={{ marginTop: '30px' }}
                type={showRePass ? 'text' : 'password'}
                value={rePassword}
                onChange={e => { setRePassword(e.target.value); setErrorRePass({ value: true, text: '' }) }}
                error={!errorRePass?.value}
                helperText={errorRePass?.text}
                InputProps={{
                    // <-- This is where the toggle button is added.
                    startAdornment: (
                        <InputAdornment position="start">
                            <LockOutlinedIcon sx={{ color: '#949595' }} />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            {rePassword !== '' ? (
                                <IconButton
                                    tabIndex={-1}
                                    aria-label="toggle password visibility"
                                    onClick={() => setRePassword('')}
                                    sx={{ p: 0.5 }}
                                >
                                    <IconClose />
                                </IconButton>
                            ) : (
                                <></>
                            )}
                            <IconButton
                                tabIndex={-1}
                                aria-label="toggle password visibility"
                                onClick={handleClickShowRePass}
                                sx={{ p: 0.5 }}
                            >
                                {showRePass ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            <Button disabled={listError?.length !== 0} style={{ backgroundColor: '#cb003d', marginTop: '30px' }} className="mb-3 w-full" onClick={handleUpdatePass}>
                {t('breadcrumb.save')}
            </Button>
        </div>
    )
}